import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const FAQ = () => {
    const [open, setOpen] = useState(0);
    const ref = useReveal();

    return (
        <section
            ref={ref}
            data-testid="faq-section"
            className="py-24 md:py-40 bg-samora-bone"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start reveal">
                        <p className="eyebrow mb-6">Frequently Asked</p>
                        <h2
                            className="font-display text-samora-ink leading-[0.95] tracking-tight"
                            style={{ fontSize: "clamp(2.5rem, 5.5vw, 4.5rem)" }}
                        >
                            Answers,<br />
                            <span className="italic font-serif text-samora-gold">
                                not sales pitches.
                            </span>
                        </h2>
                        <p className="mt-6 text-samora-text/70 text-base leading-relaxed max-w-md">
                            Still unsure? Write to us at{" "}
                            <a
                                href="mailto:sam@samoraspaces.in"
                                className="text-samora-gold underline underline-offset-4"
                            >
                                sam@samoraspaces.in
                            </a>{" "}
                            — Sam responds personally.
                        </p>
                    </div>

                    <div className="lg:col-span-8">
                        {FAQS.map((f, i) => {
                            const isOpen = i === open;
                            return (
                                <div
                                    key={i}
                                    data-testid={`faq-item-${i}`}
                                    className="border-t border-samora-ink/15 last:border-b reveal"
                                >
                                    <button
                                        onClick={() =>
                                            setOpen(isOpen ? -1 : i)
                                        }
                                        data-testid={`faq-trigger-${i}`}
                                        className="w-full py-6 md:py-8 flex items-start justify-between gap-6 text-left group"
                                        aria-expanded={isOpen}
                                    >
                                        <span
                                            className={`font-display text-xl md:text-2xl leading-snug transition-colors ${
                                                isOpen
                                                    ? "text-samora-gold"
                                                    : "text-samora-ink group-hover:text-samora-gold"
                                            }`}
                                        >
                                            {f.q}
                                        </span>
                                        <span className="flex-shrink-0 mt-1 text-samora-ink">
                                            {isOpen ? (
                                                <Minus
                                                    size={20}
                                                    strokeWidth={1.5}
                                                />
                                            ) : (
                                                <Plus
                                                    size={20}
                                                    strokeWidth={1.5}
                                                />
                                            )}
                                        </span>
                                    </button>
                                    <div
                                        className={`overflow-hidden transition-all duration-500 ${
                                            isOpen
                                                ? "max-h-[400px] opacity-100 pb-8"
                                                : "max-h-0 opacity-0"
                                        }`}
                                    >
                                        <p className="text-samora-text/75 text-base leading-relaxed max-w-2xl">
                                            {f.a}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQ;
